/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useRef, useState } from "react";

/** Common Components */
import MolGrid, { Column } from "@moltech/molui/molgrid";
import Buttons from "../../../../../../components/ui/button/Buttons";
import CardSection from "../../../../../../components/ui/card/CardSection";
import CustomCenterModel from "../../../../../../components/ui/customCenterModel/CustomCenterModel";
import { AppIcons } from "../../../../../../data/appIcons";

/** Services */
import ToastService from "../../../../../../services/toastService/ToastService";
import SwalAlert from "../../../../../../services/swalService/SwalService";

/** Utilities */
import { ContractAmendmentStatus } from "../../../../../../utils/ENUMS/ContractAmendmentStatus";
import AddAmendments from "./features/AddAmendments";

/** RTK Query */
import {
  useDeleteContractAmendmentScopeMutation,
  useDeleteContractAmendmentsMutation,
  useGetContractAmendmentScopesMutation,
  useLazyGetAmendmentsListQuery,
  useUpdateContractAmendmentScopeChangeDateMutation,
  useUpdateContractAmendmentScopeCostMutation,
  useUpdateContractAmendmentStatusMutation
} from "../../../../../../app/services/contractAPI";

import AddAmendmentsScope from "./features/AddAmendmentsScope";
import FormInputFields from "../../../../../../components/finalForms/formFields/FormInputFields";
import { format_Date } from "../../../../../../components/finalMolGrid/libs/formatDate";
import FormDatePickerFields from "../../../../../../components/finalForms/formFields/FormDatePickerField";
import { ContractContext } from "../../../../../../utils/context/ContractContext";

const Amendments = () => {
  const { contractId, contractData } = useContext(ContractContext);
  const [isModelOpen, setIsModelOpen] = useState(false);
  const gridRef = useRef();
  const [gridData, setGridData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const { confirm, confirmBox, info, confirmBoxForQuoted } = SwalAlert();
  const [isAmendmentAddScopOpen, setIsAmendmentAddScopOpen] = useState(false);
  const [amendmentScopeGridData, setAmendmentScopeGridData] = useState([]);
  const [isAmendmentScopeUpdateCost, setIsAmendmentScopeUpdateCost] = useState(false);
  const [isAmendmentScopeUpdateChangeDate, setIsAmendmentScopeUpdateChangeDate] = useState(false);

  const [updateCost, setUpdateCost] = useState();
  const [effectiveDate, setEffectiveDate] = useState(new Date());

  const [amendmentKey, setAmendmentKey] = useState();

  const [getAllAmendmentsList, {
    isLoading: isAllAmendmentsLoding,
    isSuccess: isAllAmendmentsFetching,
    data: AllAmendmentsData
  }] = useLazyGetAmendmentsListQuery();

  const [deleteAmendments, {
    isSuccess: isDeleteAmendmentFetching,
    data: deleteAmendmentsData
  }] = useDeleteContractAmendmentsMutation();


  const [UpdateContractAmendmentStatus, {
    isSuccess: isUpdateContractAmendmentStatusFetching,
    data: UpdateContractAmendmentStatusData
  }] = useUpdateContractAmendmentStatusMutation();

  const [deleteAmendmentsScop, {
    isSuccess: isDeleteAmendmentScopFetching,
    data: deleteAmendmentsScopData
  }] = useDeleteContractAmendmentScopeMutation();

  const [getAllAmendmentsScopeList, {
    isLoading: isAllAmendmentsScopeLoding,
    isSuccess: isAllAmendmentsScopeFetching,
    data: AllAmendmentsScopeData
  }] = useGetContractAmendmentScopesMutation();

  const [getUpdateCost, {
    isSuccess: isUpdateCostFetching,
    data: updateCostData
  }] = useUpdateContractAmendmentScopeCostMutation();


  const [getChangeDate, {
    isSuccess: isChangeDateFetching,
    data: updateChangeDate
  }] = useUpdateContractAmendmentScopeChangeDateMutation();

  useEffect(() => {
    getAllAmendmentsList(contractId);
  }, [contractId]);

  useEffect(() => {
    if (!isAllAmendmentsLoding && isAllAmendmentsFetching && AllAmendmentsData) {
      setGridData(AllAmendmentsData);
    }
  }, [isAllAmendmentsLoding, isAllAmendmentsFetching, AllAmendmentsData])

  useEffect(() => {
    if (isDeleteAmendmentFetching && deleteAmendmentsData) {
      if (deleteAmendmentsData) {
        ToastService.success(deleteAmendmentsData?.errorMessage);
        getAllAmendmentsList(contractId);
      }
      else {
        ToastService.error("Something went wrong");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDeleteAmendmentFetching, deleteAmendmentsData, getAllAmendmentsList]);

  useEffect(() => {
    if (isUpdateContractAmendmentStatusFetching && UpdateContractAmendmentStatusData) {
      if (UpdateContractAmendmentStatusData) {
        ToastService.success(UpdateContractAmendmentStatusData?.errorMessage);
        handleSaveSuccess()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUpdateContractAmendmentStatusFetching, UpdateContractAmendmentStatusData]);

  // Amendment Scope

  useEffect(() => {
    if (isDeleteAmendmentScopFetching && deleteAmendmentsScopData) {
      if (deleteAmendmentsScopData) {
        ToastService.success(deleteAmendmentsScopData?.errorMessage);
        refreshScopGrid();
      }
      else {
        ToastService.error("Something went wrong");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDeleteAmendmentScopFetching, deleteAmendmentsScopData]);


  useEffect(() => {
    if (!isAllAmendmentsScopeLoding && isAllAmendmentsScopeFetching && AllAmendmentsScopeData) {
      setAmendmentScopeGridData(AllAmendmentsScopeData);
    }
  }, [isAllAmendmentsScopeLoding, isAllAmendmentsScopeFetching, AllAmendmentsData])

  useEffect(() => {
    if (isUpdateCostFetching && updateCostData) {
      if (updateCostData) {
        ToastService.success(updateCostData?.errorMessage);
        handleCloseModel();
        refreshScopGrid();
      }
    }
  }, [isUpdateCostFetching, updateCostData]);

  useEffect(() => {
    if (isChangeDateFetching && updateChangeDate) {
      if (updateChangeDate) {
        ToastService.success(updateChangeDate?.errorMessage);
        handleCloseModel();
        refreshScopGrid();
      }
    }
  }, [isChangeDateFetching, updateChangeDate]);

  const handleAddClick = (rowData) => {
    setSelectedRow(rowData);
    setIsModelOpen(true);
  };

  const handleCloseModel = () => {
    setIsModelOpen(false);
    setSelectedRow(null);
    setIsAmendmentAddScopOpen(false);
    setIsAmendmentScopeUpdateCost(false);
    setIsAmendmentScopeUpdateChangeDate(false);
    setEffectiveDate(new Date());
  };

  const handleOpenModel = (row) => {
    setSelectedRow(row);
    setIsAmendmentAddScopOpen(true);
  }

  const handleSaveSuccess = async () => {
    const res = await getAllAmendmentsList(contractId).unwrap();
    setGridData(res);
  };

  const handleUpdateStatus = async (row) => {
    if (row.sContractAmendmentStatus === "Approved") {
      info(
        "Cannot Change Status",
        "You cannot change the status of an approved amendment because scopes have already been added/removed, and the invoice schedule has also potentially been updated.",
        "error",
        "OK"
      );
      return;
    }

    if (row.sContractAmendmentStatus === "Declined") {
      confirmBoxForQuoted(
        "",
        "Update Status?",
        "Quoted",
        "Approve",
        "Cancel"
      ).then(async (result) => {
        if (result === "quoted") {
          const request = {
            plContractAmendmentKey: row.lContractAmendmentKey,
            plContractAmendmentStatusKey: ContractAmendmentStatus.QUOTED
          };

          await UpdateContractAmendmentStatus(request).unwrap();
          handleSaveSuccess();
        }

        else if (result === "approve") {
          const request = {
            plContractAmendmentKey: row.lContractAmendmentKey,
            plContractAmendmentStatusKey: ContractAmendmentStatus.APPROVED
          };

          await UpdateContractAmendmentStatus(request).unwrap();
          handleSaveSuccess();
        }
        else {
          handleCloseModel();
        }
      });

      return;
    }

    confirmBox(
      "",
      "Update Status?",
      "Approve",
      "Decline",
      "Cancel"
    ).then(async (result) => {
      if (result === "approve") {
        const request = {
          plContractAmendmentKey: row.lContractAmendmentKey,
          plContractAmendmentStatusKey: ContractAmendmentStatus.APPROVED
        };

        await UpdateContractAmendmentStatus(request).unwrap();
        handleSaveSuccess();
      }
      else if (result === "decline") {
        const request = {
          plContractAmendmentKey: row.lContractAmendmentKey,
          plContractAmendmentStatusKey: ContractAmendmentStatus.DECLINED
        };

        await UpdateContractAmendmentStatus(request).unwrap();
        handleSaveSuccess();
      }
      else {
        handleCloseModel();
      }
    });
  };

  const getCtxMenuItems = (row) => {
    if (!row) return [];
    return [
      {
        label: "Delete Amendment",
        command: () => {

          const activeTr = document.querySelector("tr[tabindex='0']");

          activeTr?.classList.remove(
            "p-highlight",
            "p-highlight-contextmenu",
            "p-selectable-row"
          );

          confirm("",
            "Are you sure you want to delete this amendment?",
            "Yes",
            "No"
          ).then((confirmed) => {
            if (confirmed) {
              if (row) {
                deleteAmendments(row.lContractAmendmentKey);
              }
            }
          });
        }
      },
      {
        label: "Create Amendment Document",
        command: () => {

        }
      },
      {
        label: "Update Amendment Status",
        command: () => {
          handleUpdateStatus(row);
        }
      }
    ];
  };

  const headerContent = () => {
    return (
      <div className="d-flex justify-content-end gap-3 export-icon">
        <Buttons
          buttonText="Add Amendments"
          onClick={handleAddClick}
          buttonTypeClassName="btn blue-btn"
          titleText="Unassign Selected Items"
        // isLoading={isDeleting}
        />
      </div>
    );
  };

  const headerAmendmentScopeContent = () => {
    return (
      <div className="d-flex justify-content-end gap-3 export-icon">
        <Buttons
          buttonText="Add Amendments Scope"
          onClick={(row) => { handleOpenModel(row) }}
          buttonTypeClassName="btn blue-btn"
          titleText="Unassign Selected Items"
        // isLoading={isDeleting}
        />
      </div>
    );
  };


  const handleAmendmentScopeUpdateCost = (row) => {
    setSelectedRow(row);
    setIsAmendmentScopeUpdateCost(true);
    setUpdateCost(row?.nCost)
  }

  const handleAmendmentScopeUpdateChangeDate = (row) => {
    setSelectedRow(row);
    setIsAmendmentScopeUpdateChangeDate(true);
    setEffectiveDate(row?.dtChangeDate ? new Date(row.dtChangeDate) : new Date());
  }

  const getCtxMenuAmendmentScopeItems = (row) => {
    if (!row) return [];
    return [
      {
        label: "Add Scopes to Contract",
        command: () => {
          handleOpenModel(row);
        }
      },
      {
        label: "Remove Scopes from Contract",
        command: () => {
          // handleOpenModel(row);
        }
      },
      {
        label: "Remove Scope from Amendment",
        command: () => {
          confirm("",
            "Are you sure you want to remove this scop from the amendment?",
            "Yes",
            "No"
          ).then((confirmed) => {
            if (confirmed) {
              if (row) {
                deleteAmendmentsScop(row?.lContractAmendmentScopeKey);
              }
            }
          });
        }
      },
      {
        label: "Update Cost",
        command: () => {
          if (row.sContractAmendmentStatus === "Approved") {
            info(
              "",
              "You cannot edit this amendment because it has already been approved",
              "",
              "OK"
            );
          }
          else {
            handleAmendmentScopeUpdateCost(row);
          }
        }
      },

      {
        label: "Update Change Date",
        command: () => {
          if (row.sContractAmendmentStatus === "Approved") {
            info(
              "",
              "You cannot edit this amendment because it has already been approved",
              "",
              "OK"
            );
          }
          else {
            handleAmendmentScopeUpdateChangeDate(row);
          }
        }
      }
    ];
  };

  const handleAmendmentRowClick = (row) => {
    const contractAmendmentKey = row?.lContractAmendmentKey;
    setAmendmentKey(row?.lContractAmendmentKey);
    if (contractAmendmentKey) {

      // const activeTr = document.querySelector("tr[tabindex='0']");
      const activeTr = document.querySelector("tr[data-p-highlight-contextmenu='true']");

      activeTr?.classList.remove(
        "p-highlight",
        "p-highlight-contextmenu",
        "p-selectable-row"
      );

      getAllAmendmentsScopeList({ plContractAmendmentKey: contractAmendmentKey });
    }
    setAmendmentScopeGridData(row.data);
  };

  const refreshScopGrid = () => {
    getAllAmendmentsScopeList(
      { plContractAmendmentKey: amendmentKey }
    ).then((res) => {
      const list =
        res?.data?.result ||
        res?.data ||
        [];

      setAmendmentScopeGridData(list);
    });
  };

  const handleUpdateCost = (dataField, value) => {
    setUpdateCost(value);
  }

  const handleChangeUpdateDate = (dataField, value) => {
    setEffectiveDate(value);
  }

  const handleUpdateCostSave = (row) => {
    const request = {
      plContractAmendmentScopeKey: row.lContractAmendmentScopeKey,
      pnCost: updateCost || ''
    }
    getUpdateCost(request);
  }

  const handleUpdateChangeDate = () => {
    const terminationDate = format_Date(contractData?.dtDateTermination);

    if (effectiveDate <= terminationDate) {
      ToastService.error("Effective Date must be earlier than Termination Date.");
      return;
    }
    const request = {
      plContractAmendmentScopeKey: selectedRow.lContractAmendmentScopeKey,
      pdtChangeDate: effectiveDate
    }
    getChangeDate(request);
  }

  return (
    <div className="row gap-4">
      <div className="scrollable-grid col-12 amendment-grid-section">
        <CardSection
          cardTitle={`Add Amendments`}
          customHeader={true}
          headerContent={headerContent()}
        >
          <MolGrid
            ref={gridRef}
            value={gridData}
            grouping
            expandableRowGroups={true}
            paginator={false}
            scrollable
            scrollHeight="flex"
            filterDisplay="row"
            sortMode="single"
            showGridlines
            resizableColumns
            ctxMenuItems={getCtxMenuItems}
            selectionMode="single"
            selection={selectedRow}
            onRowClick={(e) => handleAmendmentRowClick(e.data)}
          >
            <Column
              field="dtContractAmendmentDate"
              header="Amendments Date"
              colType="datetime"
              format="mm/dd/yyyy"
              bodyStyle={{ textAlign: "Center" }}
              grouping
              sortable
            />
            <Column
              field="dtFirstBillDate"
              header="First Bill Date"
              colType="datetime"
              format="mm/dd/yyyy"
              bodyStyle={{ textAlign: "Center" }}
              grouping
              sortable
            />
            <Column
              field="nPreviousInvoiceAmount"
              header="Previous Invoice Amount"
              grouping
              sortable
              body={(rowData) => `$${Number(rowData.nPreviousInvoiceAmount).toFixed(2)}`}
              bodyStyle={{ textAlign: "Right" }}
            />
            <Column
              field="nNewInvoiceAmount"
              header="New Invoice Amount"
              grouping
              sortable
              body={(rowData) => `$${Number(rowData.nNewInvoiceAmount).toFixed(2)}`}
              bodyStyle={{ textAlign: "Right" }}
            />
            <Column field="sContractAmendmentStatus" header="Status" 
            bodyStyle={{ textAlign: "Center" }}
             grouping sortable />
          </MolGrid>
        </CardSection>
        <CustomCenterModel
          isOpen={isModelOpen}
          useCustomBg={true}
          modalTitle={"Add Amendments"}
          contentClass="content-50"
          onClose={handleCloseModel}
          modalTitleIcon={AppIcons.AddIcon}
          className="amendments-center-model"
        >
          <AddAmendments contractId={contractId} rowData={selectedRow} onClose={handleCloseModel} getAmendmentsList={getAllAmendmentsList} />
        </CustomCenterModel>
      </div>
      <div className="scrollable-grid col-12">
        <CardSection
          cardTitle={`Amendments scope`}
          customHeader={true}
          headerContent={headerAmendmentScopeContent()}
        >
          <MolGrid
            ref={gridRef}
            value={amendmentScopeGridData}
            grouping
            expandableRowGroups={true}
            paginator={false}
            scrollable
            scrollHeight="flex"
            filterDisplay="row"
            sortMode="single"
            showGridlines
            resizableColumns
            ctxMenuItems={getCtxMenuAmendmentScopeItems}
          >
            <Column
              field="addRemove"
              header="Add/Remove"
              grouping
              sortable
            />
            <Column
              field="dtChangeDate"
              header="Add/Remove Date"
              colType="datetime"
              format="mm/dd/yyyy"
              grouping
              sortable
            />
            <Column
              field="sSerialNumber"
              header="Serial#"
              grouping
              sortable
            />
            <Column field="sScopeTypeDesc" header="Model" grouping sortable />
            <Column field="sClientName1" header="Client" grouping sortable />
            <Column
              field="sDepartmentName"
              header="Department"
              grouping
              sortable
            />
            <Column field="nCost" header="Cost" body={(rowData) => `$${Number(rowData.nCost).toFixed(2)}`} grouping sortable />
          </MolGrid>
        </CardSection>
        <CustomCenterModel
          isOpen={isAmendmentAddScopOpen}
          useCustomBg={true}
          modalTitle={"Amedment Scopes"}
          contentClass="content-50"
          onClose={handleCloseModel}
          modalTitleIcon={AppIcons.AddIcon}
        >
          <AddAmendmentsScope contractId={parseInt(contractId)} amendmentRowData={gridData} amendmentScopeRowData={amendmentScopeGridData} onClose={handleCloseModel} />
        </CustomCenterModel>
        <CustomCenterModel
          isOpen={isAmendmentScopeUpdateCost}
          useCustomBg={true}
          modalTitle={"Enter total contract cost (not just remaining time)"}
          contentClass="content-30"
          onClose={handleCloseModel}
          modalTitleIcon={AppIcons.AddIcon}
        >
          <>
            <FormInputFields
              dataField="ncost"
              value={updateCost}
              labelName="Cost:"
              isRequired={true}
              type="text"
              name=""
              onChange={handleUpdateCost}
              error={updateCost === '' ? 'Cost is required' : ''}

            />
            <div className="d-flex justify-content-end gap-3 mt-3">
              <Buttons
                buttonText="Save"
                buttonTypeClassName="btn blue-btn"
                onClick={() => { handleUpdateCostSave(selectedRow) }}
              />

              <Buttons
                buttonText="Cancel"
                buttonTypeClassName="btn dark-btn"
                onClick={handleCloseModel}
              />
            </div>
          </>
        </CustomCenterModel>
        <CustomCenterModel
          isOpen={isAmendmentScopeUpdateChangeDate}
          useCustomBg={true}
          modalTitle={"Enter new Date Scope Added"}
          contentClass="content-30"
          onClose={handleCloseModel}
          modalTitleIcon={AppIcons.AddIcon}
          className="amendments-center-model"

        >
          <>
            <FormDatePickerFields
              dataField={"dtChangeDate"}
              value={effectiveDate}
              labelName={"Effective Date"}
              isRequired={true}
              onChange={handleChangeUpdateDate}
              error={effectiveDate === '' ? 'Date is required' : ''}
            />
            <div className="d-flex justify-content-end gap-3 mt-3">
              <Buttons
                buttonText="Save"
                buttonTypeClassName="btn blue-btn"
                onClick={handleUpdateChangeDate}
              />

              <Buttons
                buttonText="Cancel"
                buttonTypeClassName="btn dark-btn"
                onClick={handleCloseModel}
              />
            </div>
          </>
        </CustomCenterModel>

      </div>
    </div>
  );
};
export default Amendments;
